import { z } from 'zod';
import { requireAtLeastOneField } from '../zod-helpers/index.js';
import { createCustomerLicenseInputSchema } from './create-input.js';
import { LICENSE_DATE_ORDER_MESSAGE } from './license-date-order-message.js';
import { licenseDatesInOrder } from './license-dates-in-order.js';
const { shape } = createCustomerLicenseInputSchema;
export const updateCustomerLicenseInputSchema = requireAtLeastOneField(z.object({
    ...shape,
    licenseNumber: shape.licenseNumber.optional(),
    stateId: shape.stateId.optional(),
})).refine(licenseDatesInOrder, { path: ['expiresAt'], message: LICENSE_DATE_ORDER_MESSAGE });
//# sourceMappingURL=update-input.js.map